"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WorkflowCaseInfo_1 = require("../model/WorkflowCaseInfo");

var WorkflowCaseInfoConverter_1 = require("./WorkflowCaseInfoConverter");
/**
 * Workflow case info converter.
 *
 * @author VBr
 */


var WorkflowCaseInfoConverterImpl =
/*#__PURE__*/
function (_WorkflowCaseInfoConv) {
  _inherits(WorkflowCaseInfoConverterImpl, _WorkflowCaseInfoConv);

  function WorkflowCaseInfoConverterImpl() {
    _classCallCheck(this, WorkflowCaseInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WorkflowCaseInfoConverterImpl).apply(this, arguments));
  }

  _createClass(WorkflowCaseInfoConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WorkflowCaseInfo_1.WorkflowCaseInfo(source.id, source.wflowId, source.assignee, source.state, source.terminated, source.entity);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        id: source.id,
        wflowId: source.wflowId,
        assignee: source.assignee,
        state: source.state,
        terminated: source.terminated,
        entity: source.entity
      };
    }
  }]);

  return WorkflowCaseInfoConverterImpl;
}(WorkflowCaseInfoConverter_1.WorkflowCaseInfoConverter);

exports.WorkflowCaseInfoConverterImpl = WorkflowCaseInfoConverterImpl;